import { useState } from "react";
import { FormattedMessage } from "react-intl";
import useSWRImmutable from "swr/immutable";
import { get } from "../../../api";
import Label from "../../auth/components/Label";
import CurrencyNumber from "../../cmp/CurrencyNumber";
import LoadingSkeleton from "../../cmp/LoadingSkeleton";
import DateRangeDropdown, {
  rangeToDates,
} from "./components/DateRangeDropdown";

function TopProductsAnalytics() {
  const [selectedRange, setSelectedRange] = useState("thismonth");
  const url = `/sales/products/${rangeToDates[selectedRange].map((d) => new Date(d).getTime()).join("/")}?startDate=${rangeToDates[selectedRange][0]}&endDate=${rangeToDates[selectedRange][1]}`;
  const { data, isLoading: loading } = useSWRImmutable(url, get);
  const [limit, setLimit] = useState(5);

  return (
    <div className={"card"} style={{ width: "100%" }}>
      <div className="card-body">
        <div className="d-flex justify-content-between">
          <Label>
            <FormattedMessage id={"Products Sold"} />
          </Label>
          <DateRangeDropdown
            selectedRange={selectedRange}
            onSelected={setSelectedRange}
          />
        </div>
        <div className="display-4">
          {data ? (
            data.reduce((acc, cur) => acc + cur.quantity, 0)
          ) : (
            <LoadingSkeleton height={48} />
          )}
        </div>
      </div>
      {loading ? <LoadingSkeleton height={34} count={5} /> : null}
      {data?.length > 0 ? (
        <ul className={"list-group list-group-flush"}>
          {data.slice(0, limit).map(({ title, sku, commission, quantity }) => (
            <li
              key={title}
              className={
                "list-group-item d-flex justify-content-between align-items-center"
              }
            >
              <span>
                <span className="product-sold-title">{title}</span>{" "}
                <span className={"product-sold-sku d-none"}>{sku}</span>
              </span>
              <div className={"d-flex align-items-center"}>
                <small className={"text-success"}>
                  {commission ? <CurrencyNumber value={commission} /> : null}
                </small>
                <span className={"ml-2 badge badge-info rounded-pill"}>
                  {quantity}
                </span>
              </div>
            </li>
          ))}
        </ul>
      ) : null}
      {data?.length > limit && (
        <div className="text-center">
          <button
            className={"btn btn-link"}
            onClick={() => setLimit(data.length)}
          >
            <FormattedMessage id={"Show all"} />
          </button>
        </div>
      )}
    </div>
  );
}

export default TopProductsAnalytics;
